module.exports = __webpack_public_path__ + "fd560217b516cbeab006e17a97b5ef1a.svg";